import React, { useState, useContext, useRef } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, styled, Typography } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { GlobalContext } from '../../../../App';

// Styled image box
const StyledImgBox = styled(Box)(({ hasImage }) => ({
  width: '100%',
  height: '300px',
  border: '2px dashed #ccc',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  backgroundImage: hasImage ? 'none' : 'linear-gradient(135deg, rgba(255,0,0,0.2) 25%, transparent 25%, transparent 50%, rgba(255,0,0,0.2) 50%, rgba(255,0,0,0.2) 75%, transparent 75%, transparent)',
  backgroundSize: '40px 40px',
  backgroundColor: '#f0f0f0'
}));

const StyledImg = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
  objectFit: 'cover'
});

const ImageUploadPopup = ({ open, onClose, existingImage, imageName }) => {
  const { token } = useContext(GlobalContext);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(existingImage); // כדי להציג את התמונה הקיימת
  const fileInputRef = useRef(null); // רפרנס לקלט הקובץ

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(file);
        setPreviewImage(reader.result); // Show the image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFileButtonClick = () => {
    fileInputRef.current.click(); // פתיחת חלון בחירת הקבצים
  };

  const handleUploadClick = async () => {
    const newName = `${imageName}.jpg`;
    console.log('50', selectedImage);

    if (selectedImage) {
      const formData = new FormData();
      formData.append('image', selectedImage);
      formData.append('directory', '/gravesImages');
      formData.append('token', token);
      formData.append('imageNameWithTime', newName);

      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_PORT}/api/documents/uploadImage`, {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          onClose();
        } else {
          console.error('Upload failed');
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>עדכון תמונת הקבר</DialogTitle>
      <DialogContent>
        <StyledImgBox hasImage={!!previewImage}>{previewImage ? <StyledImg src={previewImage} alt="Selected" /> : <ImageIcon sx={{ fontSize: 80, color: '#aaa' }} />}</StyledImgBox>
        <input
          ref={fileInputRef} // שימוש ברפרנס כדי לשלוט בקלט הקובץ
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={handleImageChange}
        />
        {/* עטיפה ב-DIV עם תכונות Flex */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
          <Button variant="contained" component="span" onClick={handleFileButtonClick}>
            בחר תמונה
          </Button>
          {selectedImage && <Typography>{selectedImage.name}</Typography>}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          ביטול
        </Button>
        <Button
          onClick={handleUploadClick}
          color="primary"
          disabled={!selectedImage} // Only enable if an image is selected
        >
          העלאה
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageUploadPopup;
